import { HttpErrorResponse } from "@angular/common/http";
import { ErrorHandler, Injectable } from "@angular/core";
import { LoggingApplicationInsightsService } from "./core/services/logging-application-insights/logging-application-insights.service";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    constructor(
        private loggingApplicationInsights: LoggingApplicationInsightsService
    ) { }

    handleError(error: any): void {
        const errorSource = error;

        let actualError = errorSource;
        if (errorSource?.rejection && !(error instanceof HttpErrorResponse)) {
            actualError = errorSource.rejection;
        }

        this.loggingApplicationInsights.logException(actualError);
        console.log('Error from global error handler', actualError);
    }
}